import { AccountView } from './AccountView';
import { connect } from 'react-redux';
import {
  accountAddressRequestSel,
  accountViewIsPendingSel
} from 'src/store/modules/accountview';
import { userActions } from 'src/store/modules/user';
import { arSummaryActions } from 'src/store/modules/arSummary';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: any) => {
  return {
    addressRequest: accountAddressRequestSel(state),
    isPending: accountViewIsPendingSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getUserDetails: () => dispatch(userActions.getUserDetails()),
  getArSummary: () => {
    dispatch(arSummaryActions.getArSummary());
  }
});

export const pureComponent = AccountView;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(AccountView));

interface IDispatchFromProps {
  getUserDetails(): void;
  getArSummary(): void;
}
